var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSelect = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.96875 0L9.03125 0C9.30208 0 9.48958 0.135417 9.59375 0.40625C9.69792 0.65625 9.65625 0.875 9.46875 1.0625L5.4375 5.09375C5.3125 5.21875 5.16667 5.28125 5 5.28125C4.83333 5.28125 4.6875 5.21875 4.5625 5.09375L0.53125 1.0625C0.34375 0.875 0.302083 0.65625 0.40625 0.40625C0.510417 0.135417 0.697917 0 0.96875 0Z",
    fill: "#2F0A77"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSelect, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/iconSelect.ee7ab5bd.svg";
export { ForwardRef as ReactComponent };